import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { DataProvider } from '../providers/DataProvider';
import Clan from './Clan/Clan';
import Clans from './Clans/Clans';

const router = createBrowserRouter([
    {
        path: '/',
        element: <Clans />,
    },
    {
        path: '/:clanName',
        element: <Clan />,
    },
]);

function App() {
    return (
        <DataProvider>
            <RouterProvider router={router} />
        </DataProvider>
    );
}

export default App;
